import React from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import { renderRoutes } from 'react-router-config';
import { RoutesPath } from './RoutesPath';
import ReduxToastr from 'react-redux-toastr';
import { history } from './history';
import { AuthProvider } from '../Context/AuthContext';
import ProtectedRoute, { AdminRoute, PrimeRoute, TasksRoute, SuperAdminRoute } from './ProtectedRoute';
import Login from '../Screens/Login';
import UnAuthorized from '../Screens/UnAuthorized';
import PageNotFound from '../Screens/PageNotFound';
import ForgotPassword from '../Screens/ForgotPassword';
import ResetPassword from '../Screens/ResetPassword';
import EmailVerification from '../Components/verify/EmailVerification';
import SuperAdminHeader from '../Components/SuperAdmin/SuperAdminHeader';
import SuperAdminTenantCretion from '../Components/SuperAdmin/SuperAdminTenantCretion';
import SuperAdminTenantRemove from '../Components/SuperAdmin/SuperAdminTenantRemove';
import TenantHeader from '../Components/Tenant/TenantHeader';
import UserHeader from '../Screens/User/UserHeader';
import ImpactTemplate from '../Components/Tenant/Component/ImpactTemplate';
import TaskModule from '../Components/Tenant/TaskModule';
import Admin from '../Components/Admin/Admin';
import ChangePassword from '../Screens/ChangePassword';

const Routes = () => {
  return (
    <div>
      <ReduxToastr
        timeOut={3000}
        newestOnTop={false}
        preventDuplicates
        position="top-right"
        transitionIn="bounceIn"
        transitionOut="bounceOut"
        progressBar={false}
      />
      <AuthProvider>
        <Router history={history}>
          <Switch>
            {/* Public routes */}
            <Route exact path={process.env.PUBLIC_URL + "/"} component={Login} />
            <Route exact path={process.env.PUBLIC_URL + "/login"} component={Login} />
            <Route exact path={process.env.PUBLIC_URL + "/pagenotfound"} component={PageNotFound} />
            <Route exact path={process.env.PUBLIC_URL + "/:id/forgotPassword"} component={ForgotPassword} />
            <Route exact path={process.env.PUBLIC_URL + "/tenant/:id"} component={Login} />
            <Route exact path={process.env.PUBLIC_URL + "/user/:id"} component={Login} />
            <ProtectedRoute exact path={process.env.PUBLIC_URL + "/tenant/:id/unauthorized"} component={UnAuthorized} />
            <ProtectedRoute exact path={process.env.PUBLIC_URL + "/user/:id/unauthorized"} component={UnAuthorized} />
            <Route exact path={process.env.PUBLIC_URL + "/user/:id/emailverification/:salt"} component={EmailVerification} />
            <Route exact path={process.env.PUBLIC_URL + "/tenant/:id/resetpassword/:token"} component={ResetPassword} />
            <Route exact path={process.env.PUBLIC_URL + "/user/:id/resetpassword/:token"} component={ResetPassword} />
            <Route exact path={process.env.PUBLIC_URL + "/tenant/:id/changepassword"} component={ChangePassword} />
            <Route exact path={process.env.PUBLIC_URL + "/user/:id/changepassword"} component={ChangePassword} />
            {/* SuperAdmin routes - using specialized SuperAdminRoute for extra security */}
            <SuperAdminRoute path={process.env.PUBLIC_URL + "/superadmin/home"} component={SuperAdminHeader} />
            <SuperAdminRoute exact path={process.env.PUBLIC_URL + "/superadmin/home/Add"} component={SuperAdminTenantCretion} />
            <SuperAdminRoute exact path={process.env.PUBLIC_URL + "/superadmin/home/Remove"} component={SuperAdminTenantRemove} />
            
            {/* Special permission routes - these must come before the general protected routes */}
            <AdminRoute exact path={process.env.PUBLIC_URL + "/tenant/:id/home/admin"} component={Admin} />
            <AdminRoute exact path={process.env.PUBLIC_URL + "/user/:id/home/admin"} component={Admin} />
            <PrimeRoute exact path={process.env.PUBLIC_URL + "/tenant/:id/home/prime"} component={ImpactTemplate} />
            <PrimeRoute exact path={process.env.PUBLIC_URL + "/user/:id/home/prime"} component={ImpactTemplate} />
            <TasksRoute exact path={process.env.PUBLIC_URL + "/tenant/:id/home/taskmodule"} component={TaskModule} />
            <TasksRoute exact path={process.env.PUBLIC_URL + "/user/:id/home/taskmodule"} component={TaskModule} />
            
            {/* General protected routes */}
            <ProtectedRoute path={process.env.PUBLIC_URL + "/tenant/:id/home"} component={TenantHeader} />
            <ProtectedRoute path={process.env.PUBLIC_URL + "/user/:id/home"} component={UserHeader} />
            
            {/* Fallback route - must be last */}
            <Route component={PageNotFound} />
          </Switch>
        </Router>
      </AuthProvider>
    </div>
  );
};

export default Routes;
